import React, { FC } from "react";
import ResellerSidebar from "../Reseller/Sidebar/ResellerSidebar";
import Sidebar from "./Sidebar";
import logoVDL from '../../Assets/icons/logo-vdl.png';
import logoVDLSmall from '../../Assets/icons/logo-vdl-small.png';

interface ISidebarOrchastratorProps {}

const SidebarOrchastrator: FC<ISidebarOrchastratorProps> = () => {
  if (process.env.REACT_APP_IS_RESELLER === "true") {
    return <ResellerSidebar resellerLogo={logoVDL} resellerLogoSmall={logoVDLSmall} />;
  }

  return <Sidebar />;
}

export default SidebarOrchastrator;